import { render, staticRenderFns } from "./DNotification.vue?vue&type=template&id=0db094e8&scoped=true&"
import script from "./DNotification.vue?vue&type=script&lang=js&"
export * from "./DNotification.vue?vue&type=script&lang=js&"
import style0 from "./DNotification.vue?vue&type=style&index=0&id=0db094e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db094e8",
  null
  
)

export default component.exports